import Image from 'next/image';
import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';
import { buildImgProps } from 'utils/media';

import type { ComponentsNavBar } from 'queries/graphql';

import styles from './styles.module.scss';

export default function NavBar({ logo, links, hideOnMobile, style }: ComponentsNavBar) {
  const { linkTextColor, textFont } = style || {};
  const textFontOverrides = useTextFontOverrides(textFont);

  const rootClassNames = ['root', styles.container];
  if (hideOnMobile) rootClassNames.push(styles.hide_on_mobile);

  return (
    <nav className={rootClassNames.join(' ')}>
      <style jsx>{`
        .root {
          ${buildCssVar('--link-text-color', linkTextColor, 'var(--text-color-dark)')}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      <div className={styles.nav_wrapper}>
        <div className={styles.logo_wrapper}>
          <Image {...buildImgProps(logo)} alt={logo.alt || 'Logo'} />
        </div>

        <div className={styles.links}>
          {links.map(({ sectionId, text }) => (
            <a key={sectionId} href={`#${sectionId}`}>
              {text}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}
